// React Native Web has no built-in `fieldset` or `legend` support.
// This reset makes them consistent with other RNW views.
// Can't use RN stylesheets because it's not an RN element (RNW's createElement tooling is unstable).
// Using CSS `all` doesn't work well as an inline style.
// https://github.com/necolas/react-native-web/issues/1385
export default {
  margin: 'unset',
  padding: 'unset',
  float: 'unset',
  border: 'unset',
  width: 'unset',
  display: 'flex',
  flexDirection: 'column'
};